import { Grid, Avatar } from '@material-ui/core';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import PublicSharpIcon from '@mui/icons-material/PublicSharp';
import { Colors, Paper, Text, IfRender } from 'library';
import React from 'react';
import { IGroup } from '../models';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import theme from 'theme';
import InviteDropdown from './components/InviteDropdown/InviteDropdown';
import { isLoggedIn } from 'api/UserApi';
const useStyles = makeStyles((theme: any) => ({
    contaner: {
        marginTop: 50,
        marginBottom: 25,
        borderRadius: 25,
        backgroundColor: Colors.mediumTurq,
    },
    blue: {
        backgroundColor: Colors.darkNavy,
    },
    groupAvatar: {
        height: 140,
        width: 140,
        fontSize: '3rem',
        border: 'solid 2px #fff',
    },
}));

export default function GroupHeader({ group, about }: { group: IGroup; about: JSX.Element }) {
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    const classes = useStyles();

    function groupName(name: string) {
        return name.split(' ').reduce((initials: string, nameFragment: string) => {
            return initials + nameFragment[0];
        }, '');
    }

    return (
        <Paper className={classes.contaner}>
            <Grid container direction="row" justify="center" spacing={3}>
                <Grid container item xs={12} lg={4} justify={mdDown ? 'center' : 'flex-end'} direction="row">
                    {group?.image?.image ? (
                        <Avatar
                            alt={group?.name}
                            src={group.image.image}
                            className={`${classes.blue} ${classes.groupAvatar}`}
                        />
                    ) : (
                        <Avatar alt={group?.name} className={`${classes.blue} ${classes.groupAvatar}`}>
                            {groupName(group?.name ?? 'T G')}
                        </Avatar>
                    )}
                </Grid>
                <Grid container item xs={12} sm={8} spacing={3} direction="column" justify="center">
                    {isLoggedIn() ? (
                        <Grid container item style={{ paddingBottom: 10 }} spacing={3} alignItems="center">
                            <Text variant="display">{group?.name}</Text>
                            <IfRender condition={!xsOnly && group.is_member}>
                                <InviteDropdown group={group} />
                            </IfRender>
                        </Grid>
                    ) : (
                        <></>
                    )}
                    {smDown ? <Text variant="body2">{about}</Text> : null}
                    {smDown ? null : (
                        <Grid container item direction="row" spacing={3} style={{ alignItems: 'center' }}>
                            <AccountCircleSharpIcon style={{ color: Colors.darkNavy, marginRight: 10 }} />
                            <IfRender condition={group?.member_count !== undefined}>
                                <Text bold variant={'caption'}>
                                    {group?.member_count}
                                    {(group?.member_count as number) > 1 ? ' Members' : ' Member'}
                                </Text>
                            </IfRender>
                        </Grid>
                    )}
                    <Grid container item direction="row" spacing={3} style={{ alignItems: 'center' }}>
                        <PublicSharpIcon style={{ color: Colors.darkNavy, marginRight: 10 }} />
                        <Text bold variant={'caption'} textStyle={{ textTransform: 'capitalize' }}>
                            {group?.privacy.toLowerCase()}
                        </Text>
                    </Grid>
                    <IfRender condition={xsOnly && isLoggedIn() && group.is_member}>
                        <InviteDropdown group={group} />
                    </IfRender>
                </Grid>
            </Grid>
        </Paper>
    );
}
